const ErrorMessageView = ({errorMessage}) => (
    <div className="w-full h-fit text-xs bg-red-50 p-2 rounded-lg border-red-500 border text-red-500">{errorMessage}</div>
)

export default ErrorMessageView